import {User} from '../models';
import {UserService} from '../services';
import {Component, OnInit} from '@angular/core';
import {Router, NavigationEnd, ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-top-nav',
  templateUrl: 'topnav.html',
  styleUrls: ['./topnav.scss']
})

export class TopNavComponent implements OnInit {

  currentUser: User;
  pushRightClass = 'push-right';

  constructor(private route: ActivatedRoute, public router: Router
    , private userService: UserService) {
    this.router.events.subscribe(val => {
      if (
        val instanceof NavigationEnd &&
        window.innerWidth <= 992 &&
        this.isToggled()
      ) {
        this.toggleSidebar();
      }
    });
  }

  ngOnInit() {
    this.userService.currentUser.subscribe(
      (userData) => {
        this.currentUser = userData;
      }
    );
  }

  isToggled(): boolean {
    const dom: Element = document.querySelector('body');
    return dom.classList.contains(this.pushRightClass);
  }

  toggleSidebar() {
    const dom: any = document.querySelector('body');
    dom.classList.toggle(this.pushRightClass);
  }

  onLoggedout() {
    this.userService.purgeAuth();
    this.router.navigateByUrl('/');
  }

  subIsActive(input) {
    const paths = Array.isArray(input) ? input : [input]
    return paths.some(path => {
      return this.router.url.indexOf(path) === 0
    })
  }
}
